import { defineComponent as H, computed as g, ref as w, watch as U, createElementBlock as V, openBlock as f, createVNode as P, unref as v, withCtx as p, createBlock as B, createCommentVNode as j, Fragment as z, renderList as X, renderSlot as J, mergeProps as y, toHandlers as C, createTextVNode as Q, toDisplayString as W } from "vue";
import "@popperjs/core";
import { RevInputText as Z } from "@ds/components/InputText";
import { RevList as _ } from "@ds/components/List";
import { RevListItemInteractive as ee } from "@ds/components/ListItemInteractive";
import { RevPopover as te } from "@ds/components/Popover";
import { isEmpty as N } from "../../utils/isEmpty.js";
import { tw as L } from "../../utils/tailwind.js";
import { OPTIONS_MAX_LENGTH as re, NO_ACTIVE_OPTION as d } from "./InputAutocomplete.constant.js";
const ae = { class: "relative" }, fe = /* @__PURE__ */ H({
  name: "RevInputAutocomplete",
  inheritAttrs: !1,
  __name: "InputAutocomplete",
  props: {
    clearButtonAriaLabel: {},
    description: { default: void 0 },
    error: { default: void 0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: L`mt-8` },
    icon: { default: void 0 },
    id: {},
    label: {},
    listboxPlacement: { default: "auto" },
    options: {},
    modelValue: {},
    required: { type: Boolean, default: !1 },
    type: { default: "text" }
  },
  emits: ["update:model-value", "select-item", "focus", "blur", "input", "clear"],
  setup(n, { emit: O }) {
    const i = n, c = O, I = g(
      () => i.options.slice(0, re)
    );
    function h(e) {
      return `${i.id}-option-${e}`;
    }
    const l = w(d), b = w(!1), k = g(() => `${i.id}-listbox`);
    function s(e) {
      return e && !N(i.options);
    }
    const T = g({
      get() {
        return i.modelValue;
      },
      set(e) {
        c("update:model-value", e);
      }
    });
    function x(e) {
      if (!(!s(e) || l.value === d))
        return h(l.value);
    }
    U(I, (e) => {
      l.value = N(e) ? d : Math.min(l.value, e.length - 1);
    });
    function F(e, t) {
      t(), c("focus", e);
    }
    function S(e, t) {
      b.value || t(), c("blur", e);
    }
    function K(e) {
      l.value = d, c("input", e);
    }
    function M() {
      c("clear");
    }
    function m(e, t, a, r) {
      if (N(i.options))
        return;
      if (e.preventDefault(), !s(r)) {
        a();
        return;
      }
      const { length: o } = I.value;
      if (t === Number.NEGATIVE_INFINITY) {
        l.value = 0;
        return;
      }
      if (t === Number.POSITIVE_INFINITY) {
        l.value = o - 1;
        return;
      }
      if (l.value === d) {
        l.value = t < 0 ? o - 1 : 0;
        return;
      }
      l.value = (l.value + o + t) % o;
    }
    function R(e) {
      e();
    }
    function $(e, t, a) {
      const r = i.options[l.value];
      !r || !s(a) || (e.preventDefault(), c("select-item", r, i.id, l.value), t());
    }
    function q(e, t, a, r) {
      switch (e.key) {
        case "ArrowDown":
          m(e, 1, t, r);
          break;
        case "PageDown":
        case "End":
          m(e, Number.POSITIVE_INFINITY, t, r);
          break;
        case "ArrowUp":
          m(e, -1, t, r);
          break;
        case "PageUp":
        case "Home":
          m(e, Number.NEGATIVE_INFINITY, t, r);
          break;
        case "Escape":
          R(a);
          break;
        case "Enter":
          $(e, a, r);
          break;
      }
    }
    function D(e) {
      l.value = e;
    }
    function Y() {
      b.value = !0;
    }
    async function G(e, t, a, r, o) {
      e.preventDefault(), c("select-item", t, a, r), o(), b.value = !1;
    }
    function A({ index: e }) {
      return {
        id: h(e),
        index: e,
        role: "option",
        class: e === l.value && L`bg-static-default-min-hover`
      };
    }
    function E({
      index: e,
      option: t,
      hide: a
    }) {
      return {
        click: (r) => G(r, t, i.id, e, a),
        mousedown: () => Y(),
        mousemove: () => D(e)
      };
    }
    return (e, t) => (f(), V("div", ae, [
      P(v(te), {
        "content-class-names": "z-10 w-full",
        position: n.listboxPlacement,
        "trigger-element-id": n.id
      }, {
        trigger: p(({ show: a, hide: r, isOpen: o }) => [
          P(v(Z), y({ id: n.id }, e.$attrs, {
            modelValue: T.value,
            "onUpdate:modelValue": t[0] || (t[0] = (u) => T.value = u),
            "aria-activedescendant": x(o),
            "aria-autocomplete": "list",
            "aria-controls": k.value,
            "aria-expanded": String(s(o)),
            autocomplete: "off",
            "clear-button-aria-label": n.clearButtonAriaLabel,
            description: n.description,
            error: n.error,
            "helper-text-class": n.helperTextClass,
            icon: n.icon,
            label: n.label,
            required: n.required,
            role: "combobox",
            type: n.type,
            onBlur: (u) => S(u, r),
            onClear: M,
            onFocus: (u) => F(u, a),
            onInput: K,
            onKeydown: (u) => q(u, a, r, o)
          }), null, 16, ["id", "modelValue", "aria-activedescendant", "aria-controls", "aria-expanded", "clear-button-aria-label", "description", "error", "helper-text-class", "icon", "label", "required", "type", "onBlur", "onFocus", "onKeydown"])
        ]),
        content: p(({ hide: a, isOpen: r }) => [
          s(r) ? (f(), B(v(_), {
            key: 0,
            id: k.value,
            class: "bg-overlap-default-low shadow-long rounded-sm mt-4 overflow-hidden",
            "has-external-borders": !1,
            role: "listbox"
          }, {
            default: p(() => [
              (f(!0), V(z, null, X(I.value, (o, u) => J(e.$slots, "default", y({ ref_for: !0 }, {
                ...o,
                ...A({ index: u })
              }, C(E({ option: o, index: u, hide: a }), !0)), () => [
                (f(), B(v(ee), y({
                  key: o.key
                }, { ref_for: !0 }, A({ index: u }), C(E({ option: o, index: u, hide: a }))), {
                  label: p(() => [
                    Q(W(o.label), 1)
                  ]),
                  _: 2
                }, 1040))
              ])), 256))
            ]),
            _: 2
          }, 1032, ["id"])) : j("", !0)
        ]),
        _: 3
      }, 8, ["position", "trigger-element-id"])
    ]));
  }
});
export {
  fe as default
};
